import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import {
  searchDemandsByRegion,
  SearchDemandsByRegionRequest,
} from '@/services/search-demands-by-region'

interface UseSearchDemandsByRegion {
  regionId?: number
  payload?: SearchDemandsByRegionRequest
}

export const useSearchDemandsByRegion = ({
  regionId,
  payload = {},
}: UseSearchDemandsByRegion) => {
  return useQuery({
    queryKey: ['search-demands-by-region', regionId, payload],
    queryFn: ({ signal }) =>
      searchDemandsByRegion(regionId!, payload, {
        signal,
      }),
    enabled: !!regionId,
    onError: (error: any) => {
      toast.error(
        `Não foi possível carregar os diagnóstico para está região, tente novamente. [${error?.message}]`,
      )
    },
  })
}
